
import { ref } from "vue";
import TabBox from "./TabBox.vue";
import StoreBox from "./StoreBox.vue";
export default {
  name: "StoreDialog",
  components: {
    TabBox,
    StoreBox
  },
  setup() {
    const Dialog = ref();
    const close = () => {
      Dialog.value.close();
    };
    const open = () => {
      Dialog.value.open();
    };
    return {
      Dialog,
      close,
      open
    };
  }
};
